import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EmailVerificationPageService } from '@app/_services/email-verification-page.service';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';

@Component({
  selector: 'app-payment-successful-page',
  templateUrl: './payment-successful-page.component.html',
  styleUrls: ['./payment-successful-page.component.css']
  
})
export class PaymentSuccessfulPageComponent implements OnInit {

  Login: string;

  constructor(  private verifyDocService: VerifyDocumentService,private http: HttpClient, private emailVerificationPageService: EmailVerificationPageService) { }
  verifyMessage: string;

  ngOnInit(): void {
    const url = window.location.href;
    this.verifyMessage = "Thank you for payment";
    this.Login = "Please Click  Here to Login";
    
    
    let ids;
    if (url.includes('?')) {
    const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      ids = httpParams.get('ids');
    }
   let arIds = ids.split(',');
    this.verifyDocService.updateStudentVerificationDoc(arIds).subscribe(
      res => {
      },
      err => {
        this.verifyMessage = "Link expired Or Email already verified";
        // alert(JSON.stringify("Link expired Or Email already verified"+err.error));
        var errData = err.toString();
        //this.Login="Login";
        // alert("Error..."+errData);
      } )

  }
}
